import { Skeleton } from 'antd';
import { useState } from 'react';

interface ImageLoaderProps {
  logoData: string;
}

export const ImageLoader = ({
  logoData,
}: ImageLoaderProps): React.ReactElement => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      {isLoading && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Skeleton.Image
            style={{ width: '100%', height: '100%' }}
            active={true}
          />
        </div>
      )}

      <img
        alt="LOGO"
        src={`data:image/png;base64,${logoData}`}
        onLoad={() => setIsLoading(false)}
        style={{
          width: 290,
          height: 300,
          objectFit: 'contain',
          display: isLoading ? 'none' : 'block',
          margin: '0 auto',
        }}
      />
    </>
  );
};
